<router-outlet></router-outlet>

<ng-container *ngIf="isLoggedIn()"></ng-container>